import { ReactComponent as WarningIcon } from '../../../../icons/warning.svg';

import { Currency } from '../../../../utils/currency/Currency';
import { MACRO_DEFS, scaleMacro } from '../../../../utils/macros';
import { Button } from '../../../common/button/Button';

const sumActual = (selections) =>
  (selections ?? []).reduce(
    (acc, s) => {
      const grams = s.grams ?? 0;
      return {
        calories: acc.calories + (scaleMacro(s.item?.calories, grams) ?? 0),
        protein: acc.protein + (scaleMacro(s.item?.protein, grams) ?? 0),
        carbs: acc.carbs + (scaleMacro(s.item?.carbs, grams) ?? 0),
        fat: acc.fat + (scaleMacro(s.item?.fat, grams) ?? 0),
        price: acc.price + (s.item?.price ?? 0) * grams
      };
    },
    { calories: 0, protein: 0, carbs: 0, fat: 0, price: 0 }
  );

export const PlannedMealCard = ({ meal, onEdit, onRegenerate, regenerating }) => {
  const actual = sumActual(meal.selections);

  return (
    <div className="planned-meal-card">
      <div className="planned-meal-card__head">
        <span className="planned-meal-card__name">{meal.slotName}</span>
        {!meal.targetMet && (
          <span className="planned-meal-card__badge">
            <WarningIcon width={14} height={14} /> Target not fully met
          </span>
        )}
      </div>

      <div className="planned-meal-card__items">
        {(meal.selections ?? []).map((sel) => (
          <div key={sel.id ?? `${sel.field?.id}-${sel.item?.id}`} className="planned-meal-card__item">
            <span>{sel.item?.name}</span>
            <span>{sel.grams}g</span>
          </div>
        ))}
      </div>

      <div className="planned-meal-card__macros">
        {MACRO_DEFS.map(({ key, label, color }) => (
          <div key={key} className="planned-meal-card__macro">
            <span className="planned-meal-card__macro-value" style={{ color }}>
              {Math.round(actual[key])}
              {label}
            </span>
            <span className="planned-meal-card__macro-label">{key}</span>
          </div>
        ))}
      </div>

      <div className="planned-meal-card__footer">
        <span className="planned-meal-card__price"><Currency value={actual.price} /></span>
        <div className="planned-meal-card__actions">
          <Button secondary small onClick={() => onEdit(meal)}>Edit</Button>
          <Button secondary small onClick={() => onRegenerate(meal)} loading={regenerating}>Regenerate</Button>
        </div>
      </div>
    </div>
  );
};
